import React from 'react';
import { Modal, Form, Input, Button } from 'antd';

const VenueForm = ({ visible, onCancel, onSubmit, selectedVenue, submitting }) => {
    const [form] = Form.useForm();

    return (
        <Modal
            visible={visible}
            title={selectedVenue ? 'Edit Venue' : 'Create Venue'}
            onCancel={onCancel}
            footer={[
                <Button key="back" onClick={onCancel}>
                    Cancel
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    loading={submitting}
                    onClick={() => {
                        form
                            .validateFields()
                            .then((values) => {
                                onSubmit(values);
                                form.resetFields();
                            })
                            .catch((info) => {
                            });
                    }}
                >
                    Submit
                </Button>,
            ]}
        >
            <Form form={form} layout="vertical" initialValues={selectedVenue}>
                <Form.Item
                    name="venue"
                    label="Venue"
                    rules={[{ required: true, message: 'Please input the venue name!' }]}
                >
                    <Input />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default VenueForm;  